import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface HeroPartner {
  logo: string;
  alt: string;
}

export interface HeroData {
  title: string;
  subtitle: string;
  cta_text: string;
  cta_waitlist: string;
  badge_image_url: string | null;
  badge_alt: string | null;
  badge_active: boolean;
  logo_mobile_url: string | null;
  illustration_left_url: string | null;
  illustration_right_url: string | null;
  illustration_left_mobile_url: string | null;
  illustration_right_mobile_url: string | null;
  social_proof_text: string;
  partners: HeroPartner[];
}

const DEFAULT_HERO: HeroData = {
  title: "Računovodstvo za startupe",
  subtitle: "Od prvega računa do prvega investitorja",
  cta_text: "Rezerviraj brezplačni posvet",
  cta_waitlist: "Vpiši se na čakalni seznam",
  badge_image_url: null,
  badge_alt: "Slovenski start:up leta 2026 – Partner",
  badge_active: true,
  logo_mobile_url: null,
  illustration_left_url: null,
  illustration_right_url: null,
  illustration_left_mobile_url: null,
  illustration_right_mobile_url: null,
  social_proof_text: "Sodelujemo z vodilnimi slovenskimi inkubatorji in startup programi",
  partners: [],
};

export const useHero = () => {
  const [hero, setHero] = useState<HeroData>(DEFAULT_HERO);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      const { data } = await supabase
        .from("cms_hero")
        .select("*")
        .eq("active", true)
        .maybeSingle();
      if (mounted && data) {
        setHero({
          title: data.title ?? DEFAULT_HERO.title,
          subtitle: data.subtitle ?? DEFAULT_HERO.subtitle,
          cta_text: data.cta_text ?? DEFAULT_HERO.cta_text,
          cta_waitlist: data.cta_waitlist ?? DEFAULT_HERO.cta_waitlist,
          badge_image_url: data.badge_image_url,
          badge_alt: data.badge_alt,
          badge_active: data.badge_active ?? true,
          logo_mobile_url: data.logo_mobile_url,
          illustration_left_url: data.illustration_left_url,
          illustration_right_url: data.illustration_right_url,
          illustration_left_mobile_url: data.illustration_left_mobile_url,
          illustration_right_mobile_url: data.illustration_right_mobile_url,
          social_proof_text: data.social_proof_text ?? DEFAULT_HERO.social_proof_text,
          partners: Array.isArray(data.partners) ? (data.partners as unknown as HeroPartner[]) : [],
        });
      }
      if (mounted) setLoading(false);
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return { hero, loading };
};
